// Links to Lantern messages in text: what a preview shows.

const uuid = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";

export interface MessageLink {
  channel: string;
  // message is the message linked to: the one named, or a thread's root.
  message: string;
}

// messageLinks finds links to messages on this server (origin) in text, in
// order, each once, at most max.
export function messageLinks(text: string, origin: string, max = 3): MessageLink[] {
  const host = origin.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`${host}/c/(${uuid})/(?:m|t)/(${uuid})`, "gi");
  const out: MessageLink[] = [];
  for (const m of text.matchAll(re)) {
    const link = { channel: m[1].toLowerCase(), message: m[2].toLowerCase() };
    if (!out.some((l) => l.message === link.message)) out.push(link);
    if (out.length === max) break;
  }
  return out;
}

// permalink is the link to a message: a reply's opens its thread.
export function permalink(origin: string, m: { id: string; channel_id: string; thread_root_id?: string | null }) {
  return origin + (m.thread_root_id ? `/c/${m.channel_id}/t/${m.thread_root_id}` : `/c/${m.channel_id}/m/${m.id}`);
}
